import {Heading, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {buildSortableItemId} from '@dms/features/dnd';
import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {RenderAlbumImage} from '../types/RenderAlbumImage';
import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';
import {AlbumPhotoGrid} from './AlbumPhotoGrid';

interface PhotoBacklogProps extends RequiredTestIdProps {
  /** The album id: Backlog photos keep the album as their sortable container. */
  containerId: string;
  backlog: UnifiedAlbumImage[];
  canEdit: boolean;
  isLoading: boolean;
  isError: boolean;
  renderAlbumImage: RenderAlbumImage;
  /** Upload previews and the upload tile, rendered after the photos. */
  children?: ReactNode;
}

/** Photos of the Sales Album that are in no slot and not an Extra Photo. */
export function PhotoBacklog(props: PhotoBacklogProps) {
  return (
    <VStack spacing={2}>
      <Heading size={5}>{i18n.t('entity.photoGuide.labels.backlog')}</Heading>
      <AlbumPhotoGrid
        containerId={props.containerId}
        sortableItemIds={props.backlog.map((image, index) =>
          buildSortableItemId(image.id, props.containerId, image.url, index)
        )}
        isDropDisabled={!props.canEdit}
        isLoading={props.isLoading}
        isError={props.isError}
      >
        {props.backlog.map((image, index) =>
          props.renderAlbumImage(image, index, {
            list: props.backlog,
            testId: `backlog-[${index}]`,
            isDisabledDndDrag: !props.canEdit,
            isDisabledDndDrop: !props.canEdit,
          })
        )}
        {props.children}
      </AlbumPhotoGrid>
    </VStack>
  );
}
